$(function () {

    document.getElementById('submit-credit-card-button').addEventListener('click', function (event) {

        let ajaxData = getDivData('#donateBox')

        ajaxData.phone = ('' + ajaxData.phone).replace(/[^\d]/g, '');

        if (ajaxData.amount === undefined || parseInt(ajaxData.amount) <= 0 || isNaN(parseInt(ajaxData.amount))) {
            alert('Please select a valid donation amount.');
            return false;
        }

        if (ajaxData.email === undefined || ajaxData.email === null || (! validateEmail(ajaxData.email))) {
            alert('Invalid email address');
            return false;
        }

        if (ajaxData.phone === undefined || ajaxData.phone === null || ('' + ajaxData.phone).length <= 9) {
            alert('Invalid phone number');
            return false;
        }

        if (ajaxData.state === undefined || ajaxData.state === null || ('' + ajaxData.state).length <= 1) {
            alert('Invalid state name');
            return false;
        }

        if (ajaxData.address_1 === undefined || ajaxData.address_1 === null || ('' + ajaxData.address_1).length <= 2) {
            alert('Invalid state name');
            return false;
        }
        
        if (ajaxData.city === undefined || ajaxData.city === null || ('' + ajaxData.city).length <= 1) {
            alert('Invalid state name');
            return false;
        }

        if (ajaxData.zipcode === undefined || ajaxData.zipcode === null || ('' + ajaxData.zipcode).length <= 3) {
            alert('Invalid zipcode');
            return false;
        }

        $('.jq-error').remove();
        $('.jq-has-error').removeClass('border-danger');

        $.busyLoadFull('show')

        $.ajax({
            url: '/donation',
            type: 'POST',
            dataType: 'json',
            data: ajaxData,
        })
        .done(function(response) {
            $('.jq-donation-container').remove();
            $('.jq-programs-container').attr('class', 'jq-programs-container col-12');
            $('.jq-programs-container').find('.our_programs_block').removeClass('our_programs_block');
            $('.jq-popup-donation').show();

            try {



                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({ ecommerce: null });

                window.dataLayer.push({
                    event: 'purchase',
                    ecommerce: {
                        value: Number(ajaxData.amount),
                        transaction_id: String(response.id),
                        currency: 'USD',
                        items: [
                            {
                                item_name: "Donation",
                                price: Number(ajaxData.amount),
                                quantity: 1
                            }
                        ]
                    }
                });
                window.dataLayer.push({
                    event: 'purchase',
                });
            } catch (e) {
                console.log('google dataLayer error', e)
            }
        })
        .fail(function(response) {
            try {
                var response = response.responseJSON;

                if (response === undefined || response === null || response.message === undefined || response.message === null) {
                    alert('Something went wrong. Please try again');
                    return '';
                }

                alert(response.message);

                if (response.message === undefined && response.message === null && response.errors === undefined) {
                    alert('Something went wrong. Please try again');
                    return '';
                }

                Object.keys(response.errors).forEach(e => {
                    var error = response.errors[e]
                    console.log(error)
                    $('[name="'+e+'"]').addClass('border-danger jq-has-error').after('<span class="text-danger jq-error">'+error+'</span>')

                })
            } catch (e) {
                console.log(e)
            }
        })
        .always(function() {
            $.busyLoadFull('hide')
        });
    });
})
